// @flow
import * as React from 'react';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

// Components
import { Container, Row, Col } from 'reactstrap';
import Price from 'components/atoms/Price';
import AppointmentFlowWizard from 'components/templates/AppointmentFlowWizard/';
import AppointmentFlowFooter from 'components/molecules/AppointmentFlowFooter/';
import SelfCheckInHeader from 'components/atoms/SelfCheckInHeader/';
import ModalServicesList from 'components/molecules/ModalServicesList';
import CtaStepIndicator from 'components/atoms/CtaStepIndicator';

// Constants
import {
  SCI_VEHICLE_ROUTE,
  SCI_ADVISOR_ROUTE,
  SCI_EDIT_SERVICES_ROUTE,
  SELF_CHECK_IN_FLOW
} from 'constants/selfCheckIn';
import { NAVIGATION } from 'constants/navigations';
import { labelsStepIndicatorSCI } from 'constants/CTAConfig';

import './ReviewServicesPage.scss';

const ns = 'review-services-page';

const { FORWARD } = NAVIGATION;
const { NON_OPERATING_HOURS_CHECK_IN } = SELF_CHECK_IN_FLOW;

export type Props = {
  services: Object,
  showPrice: boolean,
  totalPrice: Object,
  servicesCount: number,
  hasPromotion: boolean,
  intl: IntlShape,
  goTo: (path: string, direction: string) => void,
  selfCheckInFlow: string,
  showSCIProgressBar: boolean
};

class ReviewServicesPage extends React.Component<Props> {
  getTotalPrice() {
    const {
      intl,
      totalPrice: { discountedPrice, price },
      showPrice,
      hasPromotion
    } = this.props;
    const totalPrice = hasPromotion ? discountedPrice : price;
    return showPrice && totalPrice === 0 ? (
      <div />
    ) : (
      <Container className={`${ns}__price-container`}>
        <Row className={`${ns}__price-row`}>
          <Col xs={8}>
            {intl.formatMessage({
              id: 'c8.self.check.in.cart.total.label'
            })}
            :
          </Col>
          <Col xs={4} className={`${ns}__price`}>
            {hasPromotion && (
              <span className={`${ns}__price--promotion`}>
                <Price value={price} showZero={true} />
              </span>
            )}
            <Price value={totalPrice} showZero={true} />
          </Col>
        </Row>
      </Container>
    );
  }

  render() {
    const {
      goTo,
      intl,
      services,
      selfCheckInFlow,
      showSCIProgressBar
    } = this.props;
    return (
      <AppointmentFlowWizard
        isSelfCheckIn={true}
        className={ns}
        showSCIProgressBar={showSCIProgressBar}
        header={() =>
          showSCIProgressBar ? (
            <CtaStepIndicator
              htmlId="VehiclePageStepIndicator"
              labels={labelsStepIndicatorSCI(intl)}
              activeStep={2}
            />
          ) : (
            <SelfCheckInHeader
              label={intl.formatMessage({
                id: 'c8.self.check.in.header.mileage'
              })}
              route={SCI_VEHICLE_ROUTE}
              buttonLabel={
                selfCheckInFlow !== NON_OPERATING_HOURS_CHECK_IN
                  ? intl.formatMessage({
                      id: 'c8.self.check.in.header.edit.services'
                    })
                  : null
              }
              onClick={() => {
                goTo(SCI_EDIT_SERVICES_ROUTE, FORWARD);
              }}
              ariaLabel={intl.formatMessage({
                id: 'c8.aria.back.to.mileage.page',
                defaultMessage: 'Back to Mileage Page'
              })}
            />
          )
        }
        footer={() => (
          <AppointmentFlowFooter
            buttonText={intl.formatMessage({
              id: 'c8.self.check.in.review.services.looks.good'
            })}
            onClick={() => {
              goTo(SCI_ADVISOR_ROUTE, FORWARD);
            }}
          />
        )}
        body={() => (
          <React.Fragment>
            {showSCIProgressBar && (
              <SelfCheckInHeader
                label={intl.formatMessage({
                  id: 'c8.self.check.in.header.mileage'
                })}
                route={SCI_VEHICLE_ROUTE}
                buttonLabel={
                  selfCheckInFlow !== NON_OPERATING_HOURS_CHECK_IN
                    ? intl.formatMessage({
                        id: 'c8.self.check.in.header.edit.services'
                      })
                    : null
                }
                onClick={() => {
                  goTo(SCI_EDIT_SERVICES_ROUTE, FORWARD);
                }}
                ariaLabel={intl.formatMessage({
                  id: 'c8.aria.back.to.mileage.page',
                  defaultMessage: 'Back to Mileage Page'
                })}
              />
            )}
            <Container>
              <h1 className={`${ns}__title mb-4`}>
                {intl.formatMessage({
                  id:
                    'c8.self.check.in.review.services.page.review.scheduled.services'
                })}
              </h1>
              {this.getTotalPrice()}
              <ModalServicesList
                serviceList={services}
                className={`${ns}__service-list`}
              />
            </Container>
          </React.Fragment>
        )}
      />
    );
  }
}

export default ReviewServicesPage;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ReviewServicesPage/ReviewServicesPage.js